import {
  GET_COMPANY_INVOICES,
  GET_COMPANY_PROFILE,
  GET_CONSUMPTION_DETAILS,
  GET_EVENT_DETAILS,
  GET_HOME_PAGE,
  GET_INVOICE_DETAILS,
  GET_PAYMENTS_FOR_INVOICE,
  GET_PREVIOUS_TOPUPS,
  GET_UPCOMING_TOPUPS,
  SET_COMPANY_VERIFIED,
} from '../../actions/company';

const initialState = {
  verified: false,
};

const companyReducer = (state = initialState, action = {}) => {
  const {
    type = '',
    companyData = {},
    isVerified = false,
    landingPageDetails = {},
    upcomingTopupsData = {},
    previousTopupsData = {},
    eventData = {},
    ordersData = {},
    invoiceData = {},
    invoiceDetails = {},
    invoicePayments = {},
  } = action;

  switch (type) {
    case GET_COMPANY_PROFILE.INITIATE: {
      return {
        ...state,
      };
    }
    case GET_COMPANY_PROFILE.SUCCESS:
      return {
        ...state,
        ...companyData,
      };
    case SET_COMPANY_VERIFIED:
      return {
        ...state,
        verified: isVerified,
      };
    case GET_HOME_PAGE.INITIATE:
      return {
        ...state,
      };
    case GET_HOME_PAGE.SUCCESS:
      return {
        ...state,
        ...landingPageDetails,
      };
    case GET_HOME_PAGE.FAILED:
      return {
        ...state,
      };
    case GET_UPCOMING_TOPUPS.INITIATE:
      return {
        ...state,
      };
    case GET_UPCOMING_TOPUPS.SUCCESS:
      return {
        ...state,
        upcomingTopupsData,
      };
    case GET_UPCOMING_TOPUPS.FAILED:
      return {
        ...state,
      };
    case GET_PREVIOUS_TOPUPS.INITIATE:
      return {
        ...state,
      };
    case GET_PREVIOUS_TOPUPS.SUCCESS:
      return {
        ...state,
        previousTopupsData,
      };
    case GET_PREVIOUS_TOPUPS.FAILED:
      return {
        ...state,
      };
    case GET_EVENT_DETAILS.INITIATE: {
      return {
        ...state,
      };
    }
    case GET_EVENT_DETAILS.SUCCESS:
      return {
        ...state,
        eventData,
      };
    case GET_EVENT_DETAILS.FAILED:
      return {
        ...state,
      };
    case GET_CONSUMPTION_DETAILS.INITIATE: {
      return {
        ...state,
      };
    }
    case GET_CONSUMPTION_DETAILS.SUCCESS:
      return {
        ...state,
        ordersData,
      };
    case GET_CONSUMPTION_DETAILS.FAILED:
      return {
        ...state,
      };
    case GET_COMPANY_INVOICES.INITIATE: {
      return {
        ...state,
      };
    }
    case GET_COMPANY_INVOICES.SUCCESS:
      return {
        ...state,
        invoiceData,
      };
    case GET_COMPANY_INVOICES.FAILED:
      return {
        ...state,
      };
    case GET_INVOICE_DETAILS.INITIATE: {
      return {
        ...state,
      };
    }
    case GET_INVOICE_DETAILS.SUCCESS:
      return {
        ...state,
        invoiceDetails,
      };
    case GET_INVOICE_DETAILS.FAILED:
      return {
        ...state,
      };
    case GET_PAYMENTS_FOR_INVOICE.INITIATE: {
      return {
        ...state,
      };
    }
    case GET_PAYMENTS_FOR_INVOICE.SUCCESS:
      return {
        ...state,
        invoicePayments,
      };
    case GET_PAYMENTS_FOR_INVOICE.FAILED:
      return {
        ...state,
      };
    default:
      return state;
  }
};

export default companyReducer;
